import React from 'react';
import { Spinner } from 'components/atoms';
import BasicCrud   from 'components/basicCrud';
import Printer     from 'services/Printer';
import RemoveButton from 'components/RemoveButton';

function Item(props) {
  let {item, editHook} = props;
  let edit = () => {
    editHook(item.id);
  }
  return (
    <button onClick={edit} id={item.id} title="Кликните для редактирования" className="list-group-item list-group-item-action">
      <div className="row">
        <span className="col-4"><strong>{item.name}</strong></span>
        <span title="Поля" className="col m-2">Поля:&nbsp;
          <b>левое:</b> {item.lmargin}mm, &nbsp;
          <b>верх:</b> {item.tmargin}mm, &nbsp;
          <b>правое:</b> {item.rmargin}mm, &nbsp;
          <b>низ:</b> {item.bmargin}mm, &nbsp;
        </span>
      </div>
    </button>
  );
}

function ItemEdit(props) {
  let {item, updateAttribute, save, cancel, remove, saving} = props;
  return (
    <form id={item.id} className="list-group-item">
      <h3>Редактировать принтер</h3>
      <div className="row">
        <div className="col-4">
          <label htmlFor="itemName">Название</label>
          <input type="text" className="form-control" id="itemName" name="name" value={item.name} onChange={updateAttribute}/>
        </div>
        <div className="col-6">
          <label>Поля</label>
          <div className="row justify-content-center">
            <div className="col-3">
              <label htmlFor="tmargin">верх</label>
              <div className="input-group mb-3">
                <input type="text" className="form-control" id="tmargin" name="tmargin" value={item.tmargin} onChange={updateAttribute}/>
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">mm</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-3">
              <label htmlFor="lmargin">левое</label>
              <div className="input-group mb-3">
                <input type="text" className="form-control" id="lmargin" name="lmargin" value={item.lmargin} onChange={updateAttribute}/>
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">mm</span>
                </div>
              </div>
            </div>
            <div className="col-3">
              <label htmlFor="rmargin">правое</label>
              <div className="input-group mb-3">
                <input type="text" className="form-control" id="rmargin" name="rmargin" value={item.rmargin} onChange={updateAttribute}/>
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">mm</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-3">
              <label htmlFor="bmargin">низ</label>
              <div className="input-group mb-3">
                <input type="text" className="form-control" id="bmargin" name="bmargin" value={item.bmargin} onChange={updateAttribute}/>
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">mm</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button type="button" disabled={saving} onClick={save} className="btn btn-primary me-2">
        { (saving && <Spinner />) }
        Сохранить
      </button>
      <button disabled={saving} type="button" onClick={cancel} className="btn btn-light">Отмена</button>
      <RemoveButton disabled={saving} remove={remove} />
    </form>
  );
}


export default class Printers extends BasicCrud {

  constructor(props) {
    super(props);
    this.listName = 'Принтеры';
    this.modelClass = Printer;
    this.state.filter = {};
  }

  renderItem = (item) => {
    if ( this.state.currentEditedItem === item.id ) {
      return <ItemEdit item={item}
        key={item.id}
        updateAttribute={this.itemUpdateAttribute}
        save={this.saveCurrentItem}
        cancel={this.cancelEditItem}
        remove={this.removeCurrentItem}
        saving={this.state.saving}
        />
    }
    return <Item item={item} editHook={this.editItem} key={item.id}/>
  }

}
